export default {
  "profile": {
    "personalDetailsSections": "Sections de détails personnels",
    "middleNameS": "Nom(s) moyen(s)",
    "preferredDisplayName": "Nom Préférence/affichage",
    "leaveBlankIfNotApplicable": "Laisser blanc s ' il n ' est pas applicable.",
    "mobileNumber": "Numéro mobile",
    "allergyDetails": "Détails d'allergie",
    "dietaryLifestyleNotes": "Notes nutritionnelles/vieillistiques",
    "searchActiveClubMembers": "Rechercher des membres actifs du club",
    "nameOrMembershipNumber": "Nom ou numéro d ' adhésion",
    "selectedMemberIsMy": "Mon membre sélectionné est mon",
    "membershipStatus": "Statut d ' admission",
    "currentAvatar": "Avatar actuel",
    "mr": "Mr",
    "mrs": "Mrs.",
    "miss": "Mlle Miss",
    "ms": "Ms",
    "dr": "Dr.",
    "prof": "Prof",
    "sir": "Monsieur.",
    "dame": "Dame.",
    "lord": "Seigneur",
    "lady": "Madame.",
    "rev": "V",
    "work": "Travail",
    "holidayHome": "Maison de vacances",
    "postal": "Postes",
    "car": "Voiture",
    "motorcycle": "Motocycle",
    "van": "Van",
    "golfBuggy": "Voiturette de golf",
    "grandparent": "Grand-parent",
    "grandchild": "Grand-enfant",
    "dependant": "Personne à charge",
    "label": "Étiquette",
    "addressType": "Type de destinataire",
    "addressLine1": "Ligne d ' adresse 1",
    "addressLine2": "Ligne d ' adresse 2",
    "townOrCity": "Ville ou ville",
    "countyStateOrRegion": "Comté, État ou région",
    "postcodeOrZIPCode": "Code postal ou code ZIP",
    "country": "Pays",
    "registrationLicencePlate": "Enregistrement / plaque d ' immatriculation",
    "make": "C'est ça.",
    "model": "Modèle",
    "colour": "Couleur",
    "vehicleType": "Type de véhicule",
    "fullName": "Nom complet",
    "relationship": "Relation",
    "alternativeTelephone": "Téléphone de remplacement",
    "emailAddress": "Adresse électronique",
    "otherDietaryRequirement": "Autres exigences alimentaires",
    "recreational": "Loisirs",
    "social": "Social",
    "club": "Club",
    "competitive": "Compétitivité",
    "elite": "Élite",
    "discardChanges": "Discard change ?",
    "youHaveUnsavedChanges": "Vous avez des changements non enregistrés.",
    "ifYouContinueYourChangesWillBeLost": "Si vous continuez, vos changements seront perdus.",
    "discard": "Renonciation",
    "removeFamilyRelationship": "Enlever la relation familiale ?",
    "thisWillRemoveTheFamilyRelationshipForBothMembers": "Cela éliminera la relation familiale pour les deux membres.",
    "thisActionCannotBeUndoneAutomatically": "Cette action ne peut être annulée automatiquement.",
    "keepRelationship": "Garder la relation",
    "removeVehicle": "Enlever le véhicule ?",
    "removeAddress": "Enlever l'adresse ?",
    "thisVehicleWillBeRemovedFromYourProfile": "Ce véhicule sera retiré de votre profil.",
    "thisAddressWillBeRemovedFromYourProfile": "Cette adresse sera retirée de votre profil.",
    "saveChanges": "Enregistrer les modifications",
    "sending": "Envoi…",
    "sendRequest": "Envoyer la demande",
    "removing": "Enlever...",
    "confirming": "Confirmation…",
    "accepting": "Accepter...",
    "confirmRemoval": "Confirmer l ' enlèvement",
    "acceptRelationship": "Accept relation",
    "keeping": "Garder...",
    "rejecting": "Rejeter...",
    "reject": "Rejet",
    "removalRequest": "Demande de suppression",
    "cancelling": "Annulant...",
    "cancelRequest": "Annuler la demande",
    "addVehicle": "Ajouter le véhicule",
    "addAddress": "Ajouter l ' adresse",
    "mainPostalAddress": "Adresse postale principale",
    "saveVehicle": "Sauvegarder le véhicule",
    "saveAddress": "Enregistrer l'adresse",
    "primary": "Primaire",
    "uploading": "Chargement...",
    "uploadNewPhoto": "Télécharger une nouvelle photo",
    "updated": "Mis à jour.",
    "memberNumberUnavailable": "Numéro de membre non disponible",
    "enterAtLeastTwoCharactersToFindAnActive": "Entrez au moins deux caractères pour trouver un membre actif du club.",
    "keepTypingToSearchActiveClubMembers": "Continuez à taper pour rechercher des membres actifs du club.",
    "noMatchingMembersFound": "Aucun membre correspondant n'a été trouvé.",
    "hasRequestedToRemoveYourFamilyRelationship": "A demandé de supprimer votre relation familiale.",
    "hasRequestedToAddYouAsTheirRelation": "A demandé de vous ajouter comme leur {relation} .",
    "relationRelationshipRequest": "{relation} demande de relation",
    "unableToRemoveVehicle": "Incapable d'enlever le véhicule.",
    "unableToRemoveAddress": "Incapable de supprimer l'adresse.",
    "weCouldNotSaveYourChangesYourEditsAre": "Nous ne pouvions pas sauvegarder vos modifications. Vos modifications sont toujours ici. Veuillez réessayer.",
    "weCouldNotLoadYourDetailsPleaseTryAgain": "Nous ne pouvions pas charger vos détails. Veuillez réessayer.",
    "yourSessionOrAccessCouldNotBeVerifiedPlease": "Votre session ou votre accès n'a pas pu être vérifié. S'il vous plaît vous connecter ou contacter le club.",
    "thisServiceIsUnavailablePleaseReopenTheAppOr": "Ce service n'est pas disponible. Veuillez réouvrir l'application ou contacter le club.",
    "pleaseCheckTheHighlightedFieldsAndTryAgain": "Veuillez vérifier les champs surlignés et essayer de nouveau.",
    "saved": "Sauvegardé.",
    "yourChangesWereSavedButTheProfileSummaryCould": "Vos changements ont été enregistrés, mais le sommaire du profil n'a pas pu se rafraîchir.",
    "refreshSummary": "Résumé de la réflexion",
    "enterAValidEmailAddress": "Entrez une adresse email valide",
    "enterAValidTelephoneNumber": "Entrez un numéro de téléphone valide",
    "invalidDate": "Date invalide",
    "dateCannotBeInTheFuture": "La date ne peut être à l ' avenir",
    "enterAMoreRecentDate": "Entrez une date plus récente",
    "addressLine1TownCityAndCountryAreRequired": "Ligne d ' adresse 1, ville et pays",
    "registrationIsRequired": "L'inscription est requise",
    "htmlIsNotAllowed": "HTML n'est pas autorisé",
    "maximumCountCharacters": "{count} caractères maximum",
    "pleaseSelectAnImageFile": "Veuillez sélectionner un fichier image",
    "pleaseChooseAnImageUnder8MB": "Veuillez choisir une image sous 8Mo",
    "unableToRemovePhoto": "Incapable de supprimer la photo",
    "unableToSavePortraitPreferenceRightNow": "Incapable d'enregistrer une préférence de portrait en ce moment.",
    "enter00360OrUseForA": "Entrez 0.0–36.0, ou utilisez + pour un handicap supérieur à +5.0.",
    "profilePhotoUpdated": "Profil photo mise à jour.",
    "ready": "Prêt",
    "yourPortraitIsNowLive": "Votre portrait est en direct.",
    "weArePreparingYourPortrait": "Nous préparons votre portrait.",
    "profilePhotoRemoved": "Profil photo enlevée.",
    "notSet": "Non défini",
    "addYourLevelForBetterMatchesAndRecommendations": "Ajoutez votre niveau pour de meilleures correspondances et recommandations.",
    "handicap": "Handicap",
    "levelNumber": "Niveau {number}",
    "notSaved": "Pas enregistré.",
    "setLevel": "Niveau de réglage",
    "currentHandicap": "Handicapé actuel",
    "currentTier": "Actuel tier",
    "golfHandicap": "Handicap de golf",
    "preparing": "Préparer...",
    "bringProfileToLife": "Apporter le profil à la vie",
    "switchToPhoto": "Interrupteur à la photo",
    "switchToLivePortrait": "Passage au portrait en direct",
    "livePortrait": "Portrait en direct",
    "sportPlayingLevel": "{sport} niveau de jeu",
    "golfHandicapNumber": "Handicap de golf {number}",
    "sportTierLevelNumber": "{sport} , {tier} niveau, niveau {number}",
    "handicapNumber": "Handicap {number}",
    "nameLivePortrait": "{name} portrait en direct",
    "viewPhoto": "Voir photo",
    "viewLivePortrait": "Voir le portrait en direct",
    "tierLevel": "Niveaux : {tier}"
  },
  "dining": {
    "somethingWentWrongPleaseTryAgain": "Quelque chose s'est mal passé.",
    "thatTableTimeWasJustBookedPleaseChooseAnother": "Ce temps de table a été réservé. Veuillez choisir un autre temps disponible.",
    "chooseAValidDateAndTimeInYourClub": "Choisissez une date et une heure valides dans le fuseau horaire de votre club.",
    "thisReservationIsNowInsideTheClubSCancellation": "Cette réservation est maintenant à l’intérieur de la fenêtre d’annulation du club. Veuillez contacter le club.",
    "yourMemberSessionHasExpiredPleaseSignInAgain": "Votre session a expiré. S'il vous plaît vous connecter à nouveau.",
    "youAppearToBeOfflineCheckYourConnectionAnd": "Vous semblez hors ligne. Vérifiez votre connexion et essayez à nouveau.",
    "thisPartySizeIsNotSupportedForOnlineReservations": "Cette taille de parti n'est pas supportée pour les réservations en ligne.",
    "thisDiningAreaIsNotTakingReservationsOnThe": "Cette salle à manger ne prend pas de réservation à la date choisie.",
    "theSelectedDateOrTimeIsInsideTheMinimum": "La date ou l'heure choisie est à l'intérieur de la période de notation minimale.",
    "onlineReservationsAreNotCurrentlyAvailableForThisDining": "Les réservations en ligne ne sont pas actuellement disponibles pour cette salle à manger.",
    "weCouldnTCheckTableAvailabilityPleaseTryAgain": "Nous ne pouvions pas vérifier la disponibilité de la table. Veuillez réessayer.",
    "noTablesAreAvailableForThatDateTryAnother": "Aucune table n'est disponible pour cette date. Essayez une autre date ou date.",
    "diningReservationsAreNotCurrentlyAvailable": "Les réservations de repas ne sont pas actuellement disponibles.",
    "someDiningInformationCouldNotBeRefreshed": "Certaines informations sur les repas ne pouvaient pas être rafraîchies.",
    "weCouldnTReadTheAvailableTimesPleaseTry": "Nous ne pouvions pas lire les temps disponibles. Veuillez réessayer.",
    "yourReservationCouldNotBeCompleted": "Votre réservation n'a pas pu être complétée.",
    "theReservationCouldNotBeCancelled": "La réservation n'a pas pu être annulée.",
    "confirmed": "Confirmé",
    "seated": "Assise",
    "noShow": "Absent",
    "diningArea": "Zone d ' essai",
    "dismissError": "Erreur de licenciement",
    "loadingDiningAreas": "Zones de repas en chargement",
    "removeOneGuest": "Supprimer un invité",
    "addOneGuest": "Ajouter un invité",
    "loadingAvailableTimes": "Chargement des heures disponibles",
    "findAvailableTables": "Trouver Tables disponibles",
    "yourSearchWasNotTreatedAsAnEmptyResult": "Votre recherche n'a pas été traitée comme un résultat vide.",
    "tryNearbyTimesAnotherDateOrAdjustYourParty": "Essayez les heures à proximité, une autre date, ou ajustez votre taille de fête.",
    "changeDate": "Date de modification",
    "allergiesAccessibilityRequirementsBirthdaysOrAnniversaries": "Allergies, exigences d'accessibilité, anniversaires ou anniversaires...",
    "reservingYourTable": "Réserver votre table...",
    "updateReservation": "Mettre à jour la réserve",
    "reserveTable": "Tableau des réserves",
    "loadingReservations": "Chargement des réservations",
    "noPreviousReservations": "Pas de réserves précédentes",
    "closeReservationDetails": "Fermer les détails de réservation",
    "diningAreaUnavailable": "Salle à manger non disponible",
    "unavailable": "Indisponible",
    "onlineCancellationIsAvailable": "L'annulation en ligne est disponible.",
    "submitted": "soumis",
    "nameDiningArea": "{name} salle à manger",
    "countGuest": "Invités : {count}",
    "countGuests": "Invités : {count}",
    "countRecent": "Récents : {count}",
    "timeUnavailable": "Temps non disponible",
    "dateUnavailable": "Date indisponible",
    "chooseADiningAreaDateAndValidPartySize": "Choisissez une salle à manger, la date et la taille de la fête valide.",
    "countRecentOne": "Récents : {count}"
  },
  "golf": {
    "preparingYourRound": "Préparer votre ronde",
    "gettingCoursesAndPlayersReady": "Obtenir des parcours et des joueurs prêts",
    "loadingScoringTees": "Chargement de tees de marque",
    "loadingActiveRounds": "Chargement des ronds actifs",
    "golfCourse": "Terrain de golf",
    "startingRound": "À partir de...",
    "startRound": "Commencez par",
    "deleteRound": "Supprimer le rond",
    "course": "Parcours",
    "golfSetupStep": "Configuration de golf: {step}",
    "strokePlay": "Jeu de course",
    "countEveryStrokeAcrossTheRound": "Comptez tous les coups à travers la ronde.",
    "stableford": "Écurie",
    "playForPointsOnEveryHole": "Jouez pour des points sur chaque trou.",
    "nameTees": " · {name} tees",
    "weCouldnTStartTheRoundNothingHasBeen": "Nous ne pouvions pas commencer la ronde. Rien n’a été enregistré — s’il vous plaît essayez à nouveau.",
    "deleteCourseRound": "Supprimer {course} rond",
    "guestName": "Invité — {name}",
    "removeName": "Supprimer {name}",
    "today": "Aujourd’hui",
    "yesterday": "Hier.",
    "checkingSportAvailability": "Vérifier la disponibilité du sport",
    "loadingClubSports": "Chargement des sports de club",
    "findingWhatSAvailableToday": "Trouver ce qui est disponible aujourd’hui",
    "playARound": "Joue un tour",
    "takeToTheCourt": "Amener au court",
    "loadingLetSPlay": "Chargement Let’s Play",
    "weCouldnTLoadThisCompletedActivity": "Nous ne pouvions pas charger cette activité complétée.",
    "momentFromName": "Moment à partir de {name}",
    "round": "ronde",
    "activity": "activité",
    "countHoles": "Trous : {count} · ",
    "countHoles225": " · {count} trous",
    "round226": "Rondes",
    "round227": "Rondes",
    "preparingYourActivitySummary": "Préparation de votre sommaire d'activité",
    "loadingActivity": "Activité de chargement",
    "roundCOMPLETE": "PARCOURS TERMINÉ",
    "countBirdie": "Birdies : {count}",
    "countBirdies": "Birdies : {count}",
    "countEagle": "Eagles : {count}",
    "countEagles": "Eagles : {count}",
    "countAlbatross": "Albatros : {count}",
    "countAlbatrosses": "Albatros : {count}",
    "countHoleInOne": "Trous en un : {count}",
    "countHolesInOne": "Trous en un : {count}",
    "weCouldnTLoadYourHistory": "Nous ne pouvions pas charger votre histoire.",
    "countHoles240": " · {count} trous",
    "round241": "Rondes",
    "round242": "Rondes",
    "birdie": "BIRDIE",
    "nicelyJudged": "Joliment jugé.",
    "cleanWork": "Travail propre.",
    "oneBetter": "C'est mieux.",
    "thatLlPlay": "Ça va jouer.",
    "eagle": "EAGLE",
    "thatLlDo": "Ça va le faire.",
    "twoBetterVeryTidy": "Deux mieux, très bien.",
    "nowWeReTalking": "Maintenant, nous parlons.",
    "exceptional": "Exceptionnelle.",
    "albatross": "ALBATROSS",
    "wellThatEscalated": "Ça s'est intensifié.",
    "threeUnderAbsurd": "Trois sous, Absurd.",
    "youDonTSeeThatEveryDay": "Vous ne le voyez pas tous les jours.",
    "ridiculousInTheBestWay": "Ridicule, de la meilleure façon.",
    "holeINONE": "TROU EN UN",
    "oneSwingThatSAllItTook": "Une balançoire. C’est tout ce qu’il a fallu.",
    "someoneSBuyingTheDrinks": "Quelqu’un achète les boissons.",
    "straightInTheHistoryBook": "Tout droit dans le livre d'histoire.",
    "perfectlyUnnecessarySecondShot": "Parfaitement inutile deuxième tir.",
    "titleForName": "{title} pour {name} .",
    "preparingYourMoment": "Préparer votre moment...",
    "continueAfterTitleForName": "Continuer après {title} pour {name}",
    "thisRoundWillBeRemovedFromLetSPlay": "Ce tour sera retiré de Let’s Play et vous ne serez pas en mesure de continuer à le marquer."
  }
}
